<template>
  <div class="cluster-selection-container">
    <div
      v-if="!clusterTool"
      class="cluster-selection-type"
      @click="setType('point')"
      :class="{ active: selectionType === 'point' }"
    >
      <div>
        <ClusterPointSVG :class="{ active_svg: selectionType === 'point' }" />
      </div>
      <div class="cluster-text">{{ $tc("Point", 1) }}</div>
    </div>

    <div
      class="cluster-selection-type"
      @click="setType('polygon')"
      :class="{ active: selectionType === 'polygon' && !creatable }"
    >
      <div>
        <ClusterPolygonSVG
          :class="{ active_svg: selectionType === 'polygon' && !creatable }"
        />
      </div>
      <div class="cluster-text">{{ $tc("Polygon", 1) }}</div>
    </div>
  </div>
</template>

<script>
import ClusterPointSVG from "@/assets/cluster_svgs/point.svg";
import ClusterPolygonSVG from "@/assets/cluster_svgs/polygon.svg";

export default {
  name: "ClusterSelectionTypeButtons",

  props: {
    selectionType: {
      type: String,
      required: true
    },
    creatable: {
      type: Boolean
    },
    clusterTool: {
      type: Boolean
    }
  },

  components: {
    ClusterPointSVG,
    ClusterPolygonSVG
  },

  methods: {
    setType(type) {
      this.$emit("setType", type);
    }
  }
};
</script>

<style scoped>
.cluster-selection-type {
  height: 40px;
  width: 50px;
  background-color: #f5f5f5;
  margin-right: 16px;
  border: 0.5px solid #bcbcbc;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #515358;
  cursor: pointer;
}

.cluster-selection-type.active {
  background-color: #d4e9ee;
  border: 0.5px solid var(--primary-highlight);
}

.cluster-selection-type.active .cluster-text {
  color: var(--primary-highlight);
}

.cluster-text {
  padding-top: 1px;
}

.cluster-selection-container {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 20px;
}

.active_svg * {
  fill: var(--primary-highlight);
  stroke: var(--primary-highlight);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/Cluster/SelectionTypeButtons.vue